import { useQuery } from "@tanstack/react-query";

import { useAuth } from "contexts/AuthContext";

export const useGetOutputQuery = (outputId: string) => {
  const { authApi } = useAuth();
  const result = useQuery({
    queryKey: ["output", outputId],
    enabled: !!outputId,
    queryFn: async () => {
      const { data } = await authApi.get<ScanOutput>(`/output/${outputId}`);
      return data;
    },
  });

  return result;
};
